import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import addpayLang from "./components/addpayLang";
export default {
  name: "payLang",
  mixins: [loadMoreList, serchSelect],
  components: {
    addpayLang: addpayLang
  },
  data: function data() {
    return {
      pagingReqFn: "languageInfoData",
      pagingReqValue: "",
      drawer: false,
      content: '',
      gameList: []
    };
  },
  activated: function activated() {
    var _this = this;

    this.$api.paymentGamesData().then(function (res) {
      if (res.code == 0) {
        _this.gameList = res.data;
      }
    });
  },
  created: function created() {
    this.getList();
  },
  methods: {
    consynopsistentView: function consynopsistentView(row) {
      this.content = row.recharge_desc;
      this.drawer = true;
    },
    del: function del(data) {
      var _this2 = this;

      var ids = data.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'languageInfoDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this2.getList(_this2.paramsData.page);
      });
    }
  }
};